import { render, staticRenderFns } from "./WithTheMenu.vue?vue&type=template&id=0529aa54&scoped=true"
import script from "./WithTheMenu.vue?vue&type=script&lang=js"
export * from "./WithTheMenu.vue?vue&type=script&lang=js"
import style0 from "./WithTheMenu.vue?vue&type=style&index=0&id=0529aa54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0529aa54",
  null
  
)

export default component.exports